function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "E3014477-01C5-470B-85B8-E13B848F41BC");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ATF_V2-3_1200px",
  transform: "translate(-915.000000, -438.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(898.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(15.000000, 316.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.96153846,15.9230769 C13.2692308,15.4615385 15.9230769,14.5384615 15.9230769,13.1538462 C15.9230769,11.0769231 15.5769231,2.07692308 11.7692308,2.07692308 C7.96153846,2.07692308 2.76923077,3.46153846 2.76923077,6.23076923 C2.76923077,8.07692308 4.5,11.3076923 7.96153846,15.9230769 Z",
  id: "Path-2-Copy",
  fill: "#E8C230",
  transform: "translate(9.346154, 9.000000) scale(-1, 1) rotate(-71.000000) translate(-9.346154, -9.000000) "
}), /*#__PURE__*/React.createElement("g", {
  id: "baseline-devices-24px",
  transform: "translate(2.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16.6153846 0 16.6153846 16.6153846 0 16.6153846"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.76923077,4.15384615 L15.2307692,4.15384615 L15.2307692,2.76923077 L2.76923077,2.76923077 C2.00769231,2.76923077 1.38461538,3.39230769 1.38461538,4.15384615 L1.38461538,11.7692308 L0,11.7692308 L0,13.8461538 L9.69230769,13.8461538 L9.69230769,11.7692308 L2.76923077,11.7692308 L2.76923077,4.15384615 Z M15.9230769,5.53846154 L11.7692308,5.53846154 C11.3884615,5.53846154 11.0769231,5.85 11.0769231,6.23076923 L11.0769231,13.1538462 C11.0769231,13.5346154 11.3884615,13.8461538 11.7692308,13.8461538 L15.9230769,13.8461538 C16.3038462,13.8461538 16.6153846,13.5346154 16.6153846,13.1538462 L16.6153846,6.23076923 C16.6153846,5.85 16.3038462,5.53846154 15.9230769,5.53846154 Z M15.2307692,11.7692308 L12.4615385,11.7692308 L12.4615385,6.92307692 L15.2307692,6.92307692 L15.2307692,11.7692308 Z",
  id: "Shape",
  fill: "#220C89",
  fillRule: "nonzero"
})))))));

var SvgGroup3 = function SvgGroup3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group3.6bf8a2ae.svg";
export { ForwardRef as ReactComponent };